import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ArkUnitOfWork, BreezeDxStoreService } from 'app/core/core.module';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BatchDetailComponent } from '../batch-detail/batch-detail.component';
import { Contribution } from 'app/core/model/entity-model';
import _ from 'lodash';
import { DevExtremeModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-overview',
    templateUrl: './cash-list.component.html',
    styleUrls: ['./cash-list.component.scss'],
    imports: [CommonModule, DevExtremeModule, CurrencyPipe, FormsModule],
    standalone: true,
})
export class CashListComponent implements OnInit {
    contributionCash: any;
    contribution: Contribution;
    contributionId: any;
    result: Subject<any> = new Subject<any>();
    specialAccountId: number;
    mode: string;
    batchId: number;

    items: CashItem[] = [
        new CashItem('cash100', '$100', 100),
        new CashItem('cash50', '$50', 50),
        new CashItem('cash20', '$20', 20),
        new CashItem('cash10', '$10', 10),
        new CashItem('cash5', '$5', 5),
        new CashItem('cash2', '$2', 2),
        new CashItem('cash1', '$1', 1),
        new CashItem('coin100', '$1 coin', 1),
        new CashItem('coin50', '$0.50', 0.5),
        new CashItem('coin25', '$0.25', 0.25),
        new CashItem('coin10', '$0.10', 0.1),
        new CashItem('coin5', '$0.05', 0.05),
        new CashItem('coin1', '$0.01', 0.01),
    ];

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private storeService: BreezeDxStoreService) {}

    ngOnInit() {
        if (this.contributionCash)
            this.items.forEach((item) => {
                item.count = this.contributionCash[item.field];
            });
    }

    calcTotal() {
        let totalAmount = 0;
        this.items.forEach((item) => {
            totalAmount += item.total;
        });
        return totalAmount;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    async save() {
        let cashTotal = 0;
        this.items.forEach((item) => {
            this.contributionCash[item.field] = item.count;
            cashTotal += item.value * (item.count || 0);
        });

        if (this.mode === 'batchCash') {
            this.contributionCash.batchId = this.batchId;
        } else {
            let contributionLine: any = null;
            _(this.contribution.lines).forEachRight((line) => {
                line.entityAspect.setDeleted();
            });
            contributionLine = await this.uow.contributionLines.createEntity();

            contributionLine.accountId = this.specialAccountId;
            contributionLine.amount = cashTotal;
            this.contribution.lines.push(contributionLine);
        }

        await this.uow.commit();
        this.result.next({ result: true });
        this.modalRef.hide();
    }

    cancel() {
        this.uow.rollback();
        this.modalRef.hide();
    }
}

class CashItem {
    field: string;
    label: string;
    value: number;
    count?: number;

    constructor(field, label, value) {
        this.field = field;
        this.label = label;
        this.value = value;
    }

    get total() {
        return this.value * (this.count || 0);
    }
}
